import { useEffect } from "react";

const PaymentProgressModal = ({ open, onClose }) => {
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-lg p-6 text-center">

        {/* Pending Icon */}
        <div className="mx-auto mb-4 w-20 h-20 rounded-full border-4 border-yellow-500 flex items-center justify-center">
          <svg
            className="w-10 h-10 text-yellow-500"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <path d="M6 2h12M6 22h12M8 2v6l4 4 4-4V2M8 22v-6l4-4 4 4v6" />
          </svg>
        </div>

        {/* Message */}
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Payment In Progress
        </h2>

        <p className="text-sm text-gray-600">
          Your payment is in progress, please check your balance after sometimes, If the issue persists, contact support.
        </p>

        {/* Button */}
        <button
          onClick={onClose}
          className="mt-5 w-full bg-yellow-600 text-white py-2.5 rounded-xl font-semibold"
        >
          Okay
        </button>

      </div>
    </div>
  );
};

export default PaymentProgressModal;